import { PromotionSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * `tenants/{tid}/promotions/{id}` — operator-authored auto-applied
 * promotions. Tenant-scoped (one promotion can target one or more
 * outlets via `conditions.outletIdIn`). Sprint 56 — drives the
 * `/loyalty/promotions` page.
 */
export function promotionsRepoFor(tenantId: string) {
  return createRepo({
    path: `tenants/${tenantId}/promotions`,
    schema: PromotionSchema,
    name: `tenants/${tenantId}/promotions`,
  });
}
